/**
 * Accès à l'application de bureau de la borne, quand l'admin y est ouverte.
 *
 * La borne ouvre l'admin dans une fenêtre Electron qui expose ce pont (voir
 * `electron/preload.ts` dans le dépôt de la borne). Ouverte depuis un poste
 * quelconque, `window.photobooth` n'existe pas : les boutons « Retour à la
 * borne » et « Éteindre la borne » ne s'affichent pas, puisqu'il n'y a pas de
 * borne derrière.
 */
export interface DesktopBridge {
  desktop: true;
  version: string;
  quit: () => Promise<void>;
  /** Absent sur une borne d'avant la séparation de l'admin. */
  closeAdmin?: () => Promise<void>;
  /**
   * Ferme l'admin et ouvre les réglages réseau (proxy) de la borne. Accessible
   * avant connexion : sans proxy, la connexion elle-même échouerait. Absent sur
   * une borne d'avant 0.2.7.
   */
  openNetworkSettings?: () => Promise<void>;
}

declare global {
  interface Window {
    photobooth?: DesktopBridge;
  }
}

export const desktop = (): DesktopBridge | undefined => window.photobooth;

export const isDesktop = (): boolean => Boolean(window.photobooth?.desktop);
